export const SET_MEETING_LEADERBOARD = "@leaderboard/setMeetingLeaderboard"
export const FETCH_MEETING_LEADERBOARD = "@leaderboard/fetchMeetingLeaderboard"